module.exports = __webpack_public_path__ + "img/132.7.6fff04fa.png";